import React from 'react';
import styles from '../index.module.less';
import classNames from 'classnames';
import { ReoIcon } from '@reolink-web/components.basic';
import { HeaderContext } from '@/components/ReolinkHeader/common';
import eventBus from '@/utils/event';

const CompCountryLangNavItem: React.FC = () => {
    const { countryTitle, langTitle, getTextByKey } = React.useContext(HeaderContext);
    return (
        <li className={ classNames(styles['nav-item'], styles['nav-item-country-lang']) }>
            <a
                className={ styles['nav-item-title'] }
                onClick={ () => {
                    eventBus.emit('countryLangModalOpen', {});
                } }
                title={ getTextByKey('country-select') }
            >
                <span className={ styles['nav-item-title-text'] }>
                    {countryTitle} ({langTitle})
                </span>

                <ReoIcon
                    name={ 'icon-icon_arrow-right' }
                    className={ styles['nav-item-title-icon'] } />
            </a>
        </li>
    );
};

export default CompCountryLangNavItem;
